// src/Components/TopSearchedAnalytics.js
import React, { useState, useEffect, useMemo } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import { FiSearch } from "react-icons/fi";
import { getMostSearchedCount } from "../../Service/apiService";
import "../../assets/css/Analytics.css";

import "react-loading-skeleton/dist/skeleton.css"; 

export default function TopSearchedAnalytics() {
  // const navigate = useNavigate();
  // const location = useLocation();

  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchTopSearchedData();
  }, []);

  const fetchTopSearchedData = async () => {
    setLoading(true);
    try {
      const result = await getMostSearchedCount();
      const validData = Array.isArray(result) ? result : [];
      setAllData(validData);
    } catch (err) {
      console.error("Error fetching top searched terms:", err);
      setAllData([]);
    } finally {
      setLoading(false);
    }
  };

 const filteredData = useMemo(() => {
  if (!allData.length) return [];

  const totalSearches = allData.reduce(
    (sum, item) => sum + item.count,
    0
  );

  const maxCount = Math.max(...allData.map((d) => d.count));

  const baseData = searchTerm.trim()
    ? allData.filter((item) =>
        item.key.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : allData;

  return baseData
    .slice(0, 10)
    .map((item, index) => ({
      ...item,
      rank: index + 1,
      percentShare: ((item.count / totalSearches) * 100).toFixed(1),
      intensityIndex: Math.round((item.count / maxCount) * 100),
    }));
}, [searchTerm, allData]);


  // const handleBack = () => {
  //   const currentPath = location.pathname;
  //   const dashboardPath = currentPath.replace("/analytics", "/dashboard");
  //   navigate(dashboardPath);
  // };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const d = payload[0].payload;
    return (
      <div className="custom-tooltip">
        <p className="tooltip-label">{d.key}</p>
        <p>Total Searches: {d.count.toLocaleString()}</p>
        <p>Share: {d.percentShare}%</p>
        <p>Intensity Index: {d.intensityIndex}/100</p>
        <p>Rank: {d.rank}</p>
      </div>
    );
  }
  return null;
};


  return (
    <div className="analytics-container">
      <div className="header-section">
        {/* <button className="back-btn" onClick={handleBack}>
          <FiArrowLeft size={16} /> Back
        </button>
        <h1 className="title">Top Searched Terms</h1> */}

        {/* Search Filter */}
        <div className="search-filter">
          <div className="search-input-wrapper">
            <FiSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search terms..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="search-input"
            />
          </div>
        </div>
      </div>

      {loading ? (
        <div className="loading">Loading top searched terms...</div>
      ) : allData.length === 0 ? (
        <div className="no-data-full">No search data available</div>
      ) : (
        <div className="analytics-content">
          <div className="top10-analytics-layout">
            {/* Left: Top 10 List */}
            <div className="analytics-card">
              <h3>
                Top Searched Terms
                {searchTerm && ` - "${searchTerm}"`}
              </h3>
              <div className="top10-list">
                {/* Header Row */}
                <div className="top10-header">
                  <span className="top10-rank-header">Rank</span>
                  <span className="top10-term-header">Term</span>
                  <span className="top10-count-header">Searches</span>
                </div>

                {/* Data Rows */}
              {filteredData.length > 0 ? (
  filteredData.map((item) => (
    <div
      key={item.rank}
      className={`top10-item ${item.rank === 1 ? "top-item" : ""}`}
    >
      <span className="top10-rank">
        {item.rank}
        {item.rank === 1 && <span className="badge"></span>}
      </span>

      <span className="top10-term">{item.key}</span>

      <span className="top10-count">
        {item.count.toLocaleString()}
        <small className="percent-share">
          ({item.percentShare}%)
        </small>
      </span>
    </div>
  ))
                ) : (
                  <div className="no-results">
                    No terms found for "{searchTerm}"
                  </div>
                )}
              </div>
            </div>

            {/* Right: Bar Chart */}
            <div className="analytics-card">
              <h3>
                Search Count Distribution
                {searchTerm && ` - "${searchTerm}"`}
              </h3>
              <div className="chart-wrapper">
                {filteredData.length > 0 ? (
                 <ResponsiveContainer width="100%" height={500}>
  <BarChart
    data={filteredData}
    layout="vertical"
    margin={{ top: 20, right: 30, left: 10, bottom: 10 }}
  >
    <XAxis
      type="number"
      domain={[0, 100]}
      tickFormatter={(v) => `${v}%`}
    />
    <YAxis
      type="category"
      dataKey="key"
      width={120}
      tick={{ fontSize: 12 }}
      reversed
    />
    <Tooltip content={<CustomTooltip />} />

    <Bar
      dataKey="intensityIndex"
      name="Search Intensity Index"
      fill="#193269ff"
      radius={[0, 6, 6, 0]}
    />
  </BarChart>
</ResponsiveContainer>

                ) : (
                  <div className="no-chart-data">No data to display</div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}